export const DATASTORE_TYPE_META = {
  shapefile: {
    icon: 'mdi-vector-polygon',
    color: 'orange',
    avatar: '#FFF4E5',
    label: 'SHAPEFILE',
  },
  tif: {
    icon: 'mdi-image-outline',
    color: 'teal',
    avatar: '#E6F4F1',
    label: 'TIF',
  },
  pdf: {
    icon: 'mdi-file-pdf-box',
    color: 'red',
    avatar: '#FDECEA',
    label: 'GEOPDF',
  },
  api: {
    icon: 'mdi-api',
    color: 'indigo',
    avatar: '#EEEDF8',
    label: 'API',
  },
}

export function getDatastoreTypeKey(item) {
  if (!item) {
    return 'shapefile'
  }
  if (
    item.details &&
    item.details.length > 0 &&
    item.details[0] &&
    item.details[0].type === 'api'
  ) {
    return 'api'
  }
  const detail = item.datastore_detail || item.datastoreDetail
  const raw = (detail && detail.type) || item.type
  const type = raw === 'tiff' ? 'tif' : raw
  if (DATASTORE_TYPE_META[type]) {
    return type
  }
  return 'shapefile'
}

export function getDatastoreDetailType(item) {
  return getDatastoreTypeKey(item)
}

export function getDatastoreTypeMeta(itemOrType) {
  const type =
    typeof itemOrType === 'string'
      ? itemOrType === 'tiff'
        ? 'tif'
        : itemOrType
      : getDatastoreTypeKey(itemOrType)
  return DATASTORE_TYPE_META[type] || DATASTORE_TYPE_META.shapefile
}

export function isRasterDatastoreType(itemOrType) {
  const type =
    typeof itemOrType === 'string'
      ? itemOrType
      : getDatastoreTypeKey(itemOrType)
  return ['tif', 'tiff', 'pdf'].includes(type)
}
